var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUbicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.318,
    height: 130.01,
    viewBox: "0 0 98.318 130.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7497",
    "data-name": "Path 7497",
    d: "M62.859,5A46.689,46.689,0,0,0,16.2,51.659c0,38.238,46.659,77.581,46.659,77.581S109.518,89.9,109.518,51.659A46.69,46.69,0,0,0,62.859,5Zm0,68.746A22.087,22.087,0,1,1,84.946,51.659,22.152,22.152,0,0,1,62.859,73.746Z",
    transform: "translate(-13.7 -2.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUbicacion);
export default __webpack_public_path__ + "static/media/Icon_Ubicacion.141be7fbccbc62b2aae473b2e4d43de4.svg";
export { ForwardRef as ReactComponent };